import { render, staticRenderFns } from "./dirForm.vue?vue&type=template&id=6c5611c2&scoped=true"
import script from "./dirForm.vue?vue&type=script&lang=js"
export * from "./dirForm.vue?vue&type=script&lang=js"
import style0 from "./dirForm.vue?vue&type=style&index=0&id=6c5611c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5611c2",
  null
  
)

export default component.exports